import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../../shared';
import { TemperatureModule } from '../temperature/temperature.module';

import { ProgramPeriodDialogComponent } from './components/program-period-dialog/program-period-dialog.component';
import { ProgramPeriodComponent } from './components/program-period/program-period.component';
import { ProgramComponent } from './components/program/program.component';
import { ScheduleComponent } from './components/schedule/schedule.component';
import { SchedulesComponent } from './components/schedules/schedules.component';
import { SelectDaysDialogComponent } from './components/select-days-dialog/select-days-dialog.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { TimemanagerComponent } from './components/timemanager.component';
import { PeriodService, ScheduleService } from './services';

@NgModule({
  imports: [SharedDependenciesModule, TemperatureModule],
  declarations: [
    TimemanagerComponent,
    TimelineComponent,
    SchedulesComponent,
    ScheduleComponent,
    ProgramComponent,
    ProgramPeriodComponent,
    ProgramPeriodDialogComponent,
    SelectDaysDialogComponent,
  ],
  exports: [TimemanagerComponent],
  providers: [ScheduleService, PeriodService],
})
export class TimemanagerModule {}
